import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getInstructorIdData } from "../../../lib/classview";
import {
  updateData,
  getStudentDayData,
  addData,
  getInstructorIdData as getInstructorDataforSchedule,
} from "../../../lib/scheduledays";

import { getInstructorDatawithClass } from "../../../lib/sessionscheduleview";
import { getInstructorStudentwithClass } from "../../../lib/instructorstudentview";
import { useAuth } from "../../../usercontext";
import { getCurrentDateInput, getCurrentTimeInput } from "../../../generalfunc";
import moment from "moment";
import ScheduleNote from "./schedulenote";

export default function InstructorScheduleDays({slug}) {
  const [instructorClass, setInstructorClass] = useState([]);
  const [instructorStudent, setInstructorStudent] = useState([]);
  const [instructorSchedule, setInstructorSchedule] = useState([]);
  const [instructorScheduleDays, setInstructorScheduleDays] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [period, setPeriod] = useState("OneDate");
  const [sNote, setSNote] = useState("");
  // const { profile, setProfile } = useAuth();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [time, setTime] = useState();
  const [showEndDate, setShowEndDate] = useState(false);

  async function GetInstructorClassData() {
    const clas = await getInstructorIdData(slug);
    if (clas[0]) {
    setInstructorClass(clas);
    setSelectedClass(clas[0].id);
    GetInstructorStudentData(clas[0].id);
    }
  }

  async function GetInstructorStudentData(classId) {
    setSNote("");
    if (classId) {
      const sched = await getInstructorDatawithClass(slug, classId);
      setInstructorSchedule(sched);
      console.log("sched", sched);

      const students = await getInstructorStudentwithClass(slug, classId);
      setInstructorStudent(students);
    }

    const schdays = await getInstructorDataforSchedule(slug);
    setInstructorScheduleDays(schdays);
  }

  /*
 var dateArray = getDates(new Date(), (new Date()).addDays(30));
 for (let i = 0; i < dateArray.length; i ++ ) {
  //alert (dateArray[i]);
 }
 */

  useEffect(() => {
    if (period !== "OneDate") setShowEndDate(true);
    else setShowEndDate(false);
  }, [period]);

  function getDateRange() {
    var addday = 0;
    var jstr = "days";

    if (period === "EveryWeek") addday = 7;
    if (period === "EveryOtherWeek") addday = 14;
    if (period === "EveryMonth") {
      addday = 1;
      jstr = "months";
    }

    var dateArray = new Array();
    var currentDate = startDate;
    while (currentDate <= endDate) {
      dateArray.push(currentDate);
      currentDate = moment(currentDate).add(addday, jstr).format("YYYY-MM-DD");
    }
    return dateArray;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
  };

  function getStudentStatus(Id, studentId) {
    const result = instructorScheduleDays.filter((days) => {
      return days.scheduleId === Id && days.studentId === studentId;
    });

    //console.log("result",instructorScheduleDays);
    if (result.length > 0) return result[0].status;
    else return "";
  }

  async function ChangeTaskStatus(scheduleId, studentId, status) {
    //console.log("ChangeTaskStatus", scheduleId,studentId, status);

    getStudentDayData(scheduleId, studentId).then((data) => {
      //console.log("data", data);
      if (data.length > 0) {
        updateData(scheduleId, studentId, status);
      } else {
        addData([
          {
            scheduleId: scheduleId,
            studentId: studentId,
            status: status,
            instructorId: slug,
          },
        ]);
      }
    });
    GetInstructorStudentData(selectedClass);
  }

  useEffect(() => {
    GetInstructorStudentData(selectedClass);
  }, [selectedClass]);

  useEffect(() => {
    setStartDate(getCurrentDateInput());
    setEndDate(getCurrentDateInput(7));
    setTime(getCurrentTimeInput());

    GetInstructorClassData();
  }, []);

  return (
    <div className="col-md-12 mx-auto">
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-0">
          <div className="checkout-form personal-address add-course-info">
            <div className="personal-info-head mb-5">
              <h4>Instructor Schedule</h4>
              <p></p>
            </div>

            <div className="row">
              <div className="col-lg-3">
                <div className="form-group">
                  <label className="form-control-label">Class</label>
                  <div className="select-container">
                    <select
                      value={selectedClass}
                      onChange={(e) => setSelectedClass(e.target.value)}
                      className="select-box"
                    >
                      {instructorClass.map(function (data, ix) {
                        return (
                          <option key={ix} value={data.id}>
                            {data.class_name}
                          </option>
                        );
                      })}
                    </select>
                    <div className="icon-container">
                      <i className="fa-solid fa-chevron-down"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6"></div>
              {/* <div className="col-lg-3">
                <div className="ticket-btn-grp mt-3">
                  <Link to="/instructor/instructor-addschedule">Schedules</Link>
                </div>
              </div> */}
            </div>

            <hr className="mt-5" />
            <div className="comman-space pb-0">
              <div className="settings-referral-blk course-instruct-blk  table-responsive">
                {/* Instructor Users */}
                <table className="table ">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Class</th>
                      <th>Date</th>
                      <th>Time</th>
                      {instructorStudent
                        ? instructorStudent.map(function (sdata) {
                            return (
                              <th key={sdata.id}>
                                {" "}
                                {sdata.name + " " + sdata.surname}
                              </th>
                            );
                          })
                        : ""}
                      <th>-</th>
                    </tr>
                  </thead>
                  <tbody>
                    {instructorSchedule
                      ? instructorSchedule.map(function (data, ix) {
                          return (
                            <>
                              <tr key={data.id}>
                                <td>{data.id}</td>
                                <td>{data.class_name}</td>
                                <td>{data.ldate}</td>
                                <td>{data.ltime.substring(0, 5)}</td>
                                {instructorStudent
  ? instructorStudent.map(function (sdata) {
      let ststatus = getStudentStatus(data.id, sdata.studentId);
      return (
        <td key={sdata.id} className="mt-4">
          <div className="select-container2 mx-2">
            {/* Select elementi yerine sadece statü durumu görünecek */}
            <div
              className={
                ststatus === "Absent"
                  ? "select-box bg-danger-subtle"
                  : ststatus === "Late"
                  ? "select-box bg-warning-subtle"
                  : ststatus === "Present"
                  ? "select-box bg-success-subtle"
                  : "select-box"
              }
            >
              {/* Seçim kutusunu kaldırıp metni doğrudan gösteriyoruz */}
              {ststatus === ""
                ? "Select"
                : ststatus === "Absent"
                ? "Absent"
                : ststatus === "Late"
                ? "Late"
                : "Present"}
            </div>
          </div>
        </td>
      );
    })
  : ""}


                                {/* {instructorStudent
                                  ? instructorStudent.map(function (sdata) {
                                      let ststatus = getStudentStatus(
                                        data.id,
                                        sdata.studentId
                                      );
                                      return (
                                        <td key={sdata.id} className="mt-4">
                                          <div className="select-container2 mx-2">
                                            <select
                                              value={sdata.id}
                                              onChange={(e) =>
                                                ChangeTaskStatus(
                                                  data.id,
                                                  sdata.studentId,
                                                  e.target.value
                                                )
                                              }
                                              className={
                                                ststatus === "Absent"
                                                  ? "select-box bg-danger-subtle"
                                                  : ststatus === "Late"
                                                  ? "select-box bg-warning-subtle"
                                                  : ststatus === "Present"
                                                  ? "select-box bg-success-subtle"
                                                  : "select-box"
                                              }
                                            >
                                              <option
                                                key={0}
                                                value=""
                                                selected={ststatus === ""}
                                              >
                                                Select
                                              </option>
                                              <option
                                                key={1}
                                                value="Absent"
                                                selected={ststatus === "Absent"}
                                              >
                                                Absent
                                              </option>
                                              <option
                                                key={2}
                                                value="Late"
                                                selected={ststatus === "Late"}
                                              >
                                                Late
                                              </option>
                                              <option
                                                key={3}
                                                value="Present"
                                                selected={
                                                  ststatus === "Present"
                                                }
                                              >
                                                Present
                                              </option>
                                            </select>
                                          </div>
                                        </td>
                                      );
                                    })
                                  : ""} */}
                                <td className="text-center">
                                  <button
                                    type="button"
                                    className="btn btn-outline-info"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapseAnswer${ix}`}
                                    aria-expanded="false"
                                    aria-controls={`#collapseAnswer${ix}`}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-arrows-angle-expand"
                                      viewBox="0 0 16 16"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"
                                      />
                                    </svg>
                                  </button>
                                </td>
                              </tr>
                              <tr
                                className="collapse"
                                id={`collapseAnswer${ix}`}
                              >
                                <td colSpan={8}>
                                  <ScheduleNote
                                    value={data.note ? data.note : ""}
                                    setValue={setSNote}
                                    scheduleId={data.id}
                                  />
                                </td>
                              </tr>
                            </>
                          );
                        })
                      : ""}
                  </tbody>
                </table>
                {/* Instructor List */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
